import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemBulkMailRoute: InvariantJiraRoute = {
	name: 'global-settings-system-bulk-mail',
	path: '/jira/settings/system/send-email',
};
